import { render, staticRenderFns } from "./APCDelconTable.vue?vue&type=template&id=2f44f68d&scoped=true"
import script from "./APCDelconTable.vue?vue&type=script&lang=js"
export * from "./APCDelconTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f44f68d",
  null
  
)

export default component.exports